import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, OnInit, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { PermissionsService } from '../../services/permissions.service';
import { ServiceCardsService } from '../../services/service-cards.service';
import { MatCardModule } from '@angular/material/card';
import { Card } from '../../models/card.model';
import { MatButtonModule } from '@angular/material/button';
import { getPolishPaginatorIntl } from '../../polish-paginator-intl';

import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { ModalServiceCardComponent } from '../modal-service-card/modal-service-card.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ModalQrComponent } from '../modal-qr/modal-qr.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-service-cards',
  imports: [
    CommonModule,
    MatIconModule,
    MatTableModule,
    MatCardModule,
    MatPaginatorModule,
    MatButtonModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule
  ],
  templateUrl: './service-cards.component.html',
  styleUrl: './service-cards.component.css',
  providers: [{ provide: MatPaginatorIntl, useValue: getPolishPaginatorIntl() }]
})
export class ServiceCardsComponent implements OnInit, AfterViewInit {

  public dialogRef?: MatDialogRef<ModalServiceCardComponent>;
  public dialogQrRef?: MatDialogRef<ModalQrComponent>;
  readonly dialog = inject(MatDialog);


  public cards: Card[] = [];


  public displayedColumns: string[] = [
    'description',
    'type',
    'uuid',
    'pin',
    'active',
    'action'
  ];

  public dataSource = new MatTableDataSource<any>(this.cards);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;


  constructor(
    public router: Router,
    public permissionsService: PermissionsService,
    public cardsService: ServiceCardsService

  ) {
  }

  ngOnInit(): void {
    this.cards = [];
    this.fetchCards();

  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  fetchCards() {
    this.cardsService.fetchCards()
      .subscribe({
        next: (cards: any) => {
          this.cards = cards;
          this.dataSource.data = this.cards;
        },
        error: (error: any) => {
          console.error(error);
          if (error.status == 401) {
            this.router.navigate(['/login']);
          }
        }
      });

  }

  deleteElement(card: Card) {
    if (confirm("Na pewno usunąć " + card.description + "?")) {
      this.cardsService.deleteCard(card.id)
        .subscribe({
          next: (response: any) => {
            console.log(response);
            this.fetchCards();
          },
          error: error => {
            console.log("error subscribe deleteCard ", error);
            alert("Error durnig operation delete")
          }
        });
    }
  }

  doFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    //console.log("do filter arg", filterValue)
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }

  createCard() {
    return new Card(
      0,
      'SERVICE_CARD',
      crypto.randomUUID(),
      "0000",
      false,
      "");
  }


  addCard() {
    this.openDialog(this.createCard());
  }

  editCard(card: Card) {
    //this.router.navigate(['/users/edit', id]);
    //this.cardsService.setCard(card);
    this.openDialog(card);
  }

  generateQrCode(card: Card) {
    this.cardsService.setCard(card);

    this.openQrCard(card);

    /*this.cardsService.generateQrCode(card.id)
      .subscribe({
        next: (response: any) => {
          console.log(response);
          this.fetchCards();
        },
        error: error => {
          console.log("error subscribe generateQrCode ", error);
          alert("Error durnig operation generateQrCode")
        }
      });*/
  }


  openDialog(card: Card): void {

    this.cardsService.setCard(card);

    this.dialogRef = this.dialog.open(ModalServiceCardComponent, {
      width: "800px"
    });

    this.dialogRef.afterClosed().subscribe(result => {
      this.fetchCards();
    });
  }


  openQrCard(card: Card): void {

    this.cardsService.setCard(card);

    this.dialogQrRef = this.dialog.open(ModalQrComponent, {
      width: "1200px"
    });

    this.dialogQrRef.afterClosed().subscribe(result => {
      //this.fetchCards();
    });
  }

  getStatus(element: Card) {
    return element.active ? "Aktywna" : "Nieaktywna";
  }

  getType(element: Card) {
    return element.type == 'SERVICE_CARD' ? "Karta serwisowa" : "Karta integracyjna";
  }

}
